import { type StyleProp, type ViewStyle } from 'react-native';
import {
    BodyMediumRegular,
    Button,
    ButtonSize,
    ButtonVariant,
    Icon,
    ShieldCheckIcon,
    XStack,
    YStack,
} from 'smoothie';

interface KycButtonProps {
    onPress: () => void;
    disabled?: boolean;
    text?: string;
    hideSecureText?: boolean;
    style?: StyleProp<ViewStyle>;
}

const KycButton = ({
    onPress,
    disabled,
    text = 'Continue',
    hideSecureText = false,
    style,
}: KycButtonProps) => {
    return (
        <YStack gap={16} paddingTop={12}>
            {!hideSecureText && (
                <XStack alignItems="center" justifyContent="center" gap={8}>
                    <Icon icon={ShieldCheckIcon} size={14} color="$gray1000" />
                    <BodyMediumRegular color="$gray1000">
                        Your information is secure
                    </BodyMediumRegular>
                </XStack>
            )}
            <Button
                variant={ButtonVariant.PRIMARY}
                size={ButtonSize.LARGE}
                text={text}
                onPress={onPress}
                style={style}
                disabled={disabled}
            />
        </YStack>
    );
};

export default KycButton;
